import { Stack } from 'components/Stack'
import { pxToRem } from 'utils/styled'
import { mutateAnalyticsData } from 'utils/analytics'
import { IPartnerLanding } from 'api/contentful/contentful.types'
import { Button } from 'components/button/Button'

export function SignUpComponent(props: {
  partnerLandingCms?: IPartnerLanding
  actionRedirect: string
}) {
  return (
    <Stack orientation="horizontal" space={`${pxToRem(30)}rem`}>
      <Button
        type="button"
        size="large"
        href={props.actionRedirect}
        onClick={() => mutateAnalyticsData({ button: 'get_started_cta_upper' })}
      >
        {props.partnerLandingCms?.landingButtonText ?? 'Get Started Now'}
      </Button>
    </Stack>
  )
}
